import { useContext, Dispatch } from "react";

import { StateContext } from "config/state";

export const initialState = {
  tenantsFilters: {
    pagination: { rowsPerPage: 10 },
    orderBy: ["tenantName,ASC"]
  },
  primeCoursesFilters: {
    pagination: { rowsPerPage: 10 }
  }
};

type State = typeof initialState;

export enum actionTypes {
  SET_TENANTS_FILTERS = "setTenantsFilters",
  RESET_TENANTS_FILTERS = "resetTenantsFilters",
  SET_PRIME_COURSES_FILTERS = "setPrimeCoursesFilters",
  RESET_PRIME_COURSES_FILTERS = "resetPrimeCoursesFilters"
}

const reducer = (
  state = initialState,
  action: { type: actionTypes; payload?: any }
) => {
  switch (action.type) {
    case actionTypes.SET_TENANTS_FILTERS: {
      return {
        ...state,
        tenantsFilters: action.payload
      };
    }
    case actionTypes.RESET_TENANTS_FILTERS: {
      return {
        ...state,
        tenantsFilters: initialState.tenantsFilters
      };
    }
    case actionTypes.SET_PRIME_COURSES_FILTERS: {
      return {
        ...state,
        primeCoursesFilters: action.payload
      };
    }
    case actionTypes.RESET_PRIME_COURSES_FILTERS: {
      return {
        ...state,
        primeCoursesFilters: initialState.primeCoursesFilters
      };
    }
    default:
      return state;
  }
};

export const useModuleState = (): [
  State,
  Dispatch<{ type: actionTypes; payload?: any }>
] => {
  const [state, dispatch] = useContext(StateContext);
  return [state.tenants, dispatch];
};

export default reducer;
